import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { PagerService, Oper, AlertService, PortService, PortNmMapModel, SaveLocationModel, TableHeader, CommonService, P2pScheduleSubModel, VesselService, Port } from '../../services/index'
import { Util } from '../../utils/util'
import _ from 'lodash';
import similarity from 'string-similarity';
import { Subscription } from 'rxjs/Subscription';

declare var $:any;

@Component({
  selector: 'port-map-list',
  templateUrl: 'port-map-list.html' 
})
export class PortMapList implements OnInit{

    @Output() onFindPort: EventEmitter<any> = new EventEmitter();
    
    tabIndex:number = 0;
    isOpenPortMapUpdate = false;
    updTargetList:Array<PortNmMapModel> = new Array();

    //Tab 1
    _locationId:number;
    operList:Array<Oper> = new Array();

    @Input() portList:Array<Port> = new Array();

    @Input() set locationId(locationId:number){
        this._locationId = locationId;
        if(locationId == null || locationId == undefined) return;
        this.getPortMapListByLocationId(locationId, true);
        this.getFclScheduleSubLocationBroup(locationId, true);
    }
    get locationId(){
        return this._locationId;
    }

    allPortMapList: Array<PortNmMapModel> = new Array();
    portMapList: Array<PortNmMapModel> = new Array();
    pagedItems: Array<PortNmMapModel> = new Array();
    tempPortMapList: Array<PortNmMapModel> = new Array();
    
    pager: any = {};

    condition:ConditionSearch = new ConditionSearch();
    

    dateFomatter: Function = Util.dateFomatter;

    clickedPortNmMapId:number;

    allMappingMapChecked = false;

    headerList1:Array<TableHeader> = null;

    //Tab 2
    condition2:ConditionSearch = new ConditionSearch();
    pager2: any = {};

    allPortMapList2: Array<PortNmMapModel> = new Array();
    portMapList2: Array<PortNmMapModel> = new Array();
    pagedItems2: Array<PortNmMapModel> = new Array();

    clickedPortNmMapId2:number;

    headerList2:Array<TableHeader> = null;

    //Tab 3

    headerList3:Array<TableHeader> = null;

    pager3: any = {};

    allFclScheduleSub: Array<P2pScheduleSubModel> = new Array();
    fclScheduleSub: Array<P2pScheduleSubModel> = new Array();
    pagedItems3: Array<P2pScheduleSubModel> = new Array();

    clickedId3:number;

    condition3:ConditionSearch = new ConditionSearch();

    oceanLineListEeSub:Subscription;
      
    constructor(
        private portService:PortService,
        private pagerService: PagerService,
        private alertService:AlertService,
        private commonService:CommonService,
        private vesselService:VesselService
    ) {}

    ngOnInit(){
        this.getPortMapList(true);
        this.makeHeaderTab1();
        this.makeHeaderTab2();
        this.makeHeaderTab3();

        this.commonService.headerSortedEmit.subscribe(data =>{
            if(data.type == 1){
                this.allPortMapList = data.data;
                this.search(null, null);
            }else if(data.type == 2){
                this.allPortMapList2 = data.data;
                this.search2(false);
            }else if(data.type == 3){
                this.allFclScheduleSub = data.data;
                this.search3(false);
            }
          });
        this.commonService.clearHeaderEmit.subscribe(data =>{
            if(data.type == 1){
                this.headerList1 = data.headerList;
            }else if(data.type == 2){
                this.headerList2 = data.headerList;
            }else if(data.type == 3){
                this.headerList3 = data.headerList;
            }
        });


        let tempList:Array<Oper> = new Array();
        this.oceanLineListEeSub = this.vesselService.oceanLineListEe.subscribe( data => {
            for(let ocean of this.vesselService.oceanLineList){
                let oper = new Oper();
                oper.operCd = ocean.lineCd;
                oper.operNm = ocean.lineNm;
                oper.operTpCd = 0;
                oper.operTpNm = 'SHIP_OPERATOR';
                this.operList.push(oper);
            }
        });
        this.vesselService.getOceanLineList();
    }

    ngOnDestroy(){
        if(this.oceanLineListEeSub) this.oceanLineListEeSub.unsubscribe();
    }

    makeHeaderTab1(){
        this.headerList1 = new Array<TableHeader>();
        this.headerList1.push(new TableHeader(0, 'isChecked', '선택', false));
        this.headerList1.push(new TableHeader(1, 'portNmMapId', 'No.', true));
        this.headerList1.push(new TableHeader(2, 'operCd', '수집선사', true));
        this.headerList1.push(new TableHeader(3, 'operPortNm', '수집 항구명', true));
        this.headerList1.push(new TableHeader(4, 'operTpNm', '수집 타입', true));
        this.headerList1.push(new TableHeader(5, 'stusNm', '상태', true));
        this.headerList1.push(new TableHeader(6, 'location.name', '매핑 항구명', true));
        this.headerList1.push(new TableHeader(7, 'location.latitude', '매핑 위도', true));
        this.headerList1.push(new TableHeader(8, 'location.longitude', '매핑 경도', true));
        this.headerList1.push(new TableHeader(9, 'location.timeZone', '매핑 시간', true));
        this.headerList1.push(new TableHeader(10, 'remark', '기타', true));
        this.headerList1.push(new TableHeader(11, 'reqDtm', '등록일', true));
        this.headerList1.push(new TableHeader(12, 'modifyUser.lastNm', '수정자', true));
        this.headerList1.push(new TableHeader(13, 'modifyDate', '수정일', true));
    }

    makeHeaderTab2(){
        this.headerList2 = new Array<TableHeader>();
        this.headerList2.push(new TableHeader(0, 'portNmMapId', 'No.', true));
        this.headerList2.push(new TableHeader(1, 'operCd', '수집선사', true));
        this.headerList2.push(new TableHeader(2, 'operPortNm', '수집 항구명', true));
        this.headerList2.push(new TableHeader(3, 'operTpNm', '수집 타입', true));
        this.headerList2.push(new TableHeader(4, 'stusNm', '상태', true));
        this.headerList2.push(new TableHeader(5, 'location.name', '매핑 항구명', true));
        this.headerList2.push(new TableHeader(6, 'location.latitude', '매핑 위도', true));
        this.headerList2.push(new TableHeader(7, 'location.longitude', '매핑 경도', true));
        this.headerList2.push(new TableHeader(8, 'location.timeZone', '매핑 시간', true));
        this.headerList2.push(new TableHeader(9, 'remark', '기타', true));
        this.headerList2.push(new TableHeader(10, 'reqDtm', '등록일', true));
        this.headerList2.push(new TableHeader(11, 'modifyUser.lastNm', '수정자', true));
        this.headerList2.push(new TableHeader(12, 'modifyDate', '수정일', true));
    }

    makeHeaderTab3(){
        this.headerList3 = new Array<TableHeader>();
        this.headerList3.push(new TableHeader(0, 'no', 'No.', false));
        this.headerList3.push(new TableHeader(1, 'oceanLine.lineCd', '운영 코드', true));
        this.headerList3.push(new TableHeader(2, 'oceanLine.lineNm', '운영사', true));
        this.headerList3.push(new TableHeader(3, 'depLocation.cntryNm', '출발 국가', true));
        this.headerList3.push(new TableHeader(4, 'depLocation.portNm', '출발 항구명', true));
        this.headerList3.push(new TableHeader(5, 'arrLocation.cntryNm', '도착 국가', true));
        this.headerList3.push(new TableHeader(6, 'arrLocation.portNm', '도착 항구명', true));
    }
    

    getPortMapList(isInit:boolean){
        if(this.condition.status == 99){
            this.portService.getPortMapList().subscribe(
                res =>{
                    if(res != null && res.result){
                        this.portMapList = res.data;
                        this.allPortMapList = res.data;
                        this.search(null, null);
                        if(!isInit) {
                            if(this.locationId != null && this.locationId != undefined){
                                this.getPortMapListByLocationId(this.locationId, false);
                            }
                        }
                    }
                }
            );
        }else{
            this.portService.getPortMapListByStatus(Number(this.condition.status)).subscribe(
                res =>{
                    if(res != null && res.result){
                        this.portMapList = res.data;
                        this.allPortMapList = res.data;
                        this.search(null, null);
                        if(!isInit) {
                            if(this.locationId != null && this.locationId != undefined){
                                this.getPortMapListByLocationId(this.locationId, false);
                            }
                        }
                    }
                }
            );
        }
    }  

    getPortMapListByLocationId(locationId:number, isInit:boolean){
        this.portService.getPortMapListByLocationId(locationId).subscribe(
            res =>{
                if(res != null && res.result){
                    this.portMapList2 = res.data;
                    this.allPortMapList2 = res.data;
                    if(isInit) this.setPage2(1);
                    else{
                        this.search2(false);
                    }
                }
            }
        );
    }

    getFclScheduleSubLocationBroup(locationId:number, isInit:boolean){
        // this.portService.getFclScheduleSubLocationBroup(locationId, locationId).subscribe(
        //     res =>{
        //         if(res != null && res.result){
        //             this.allFclScheduleSub = res.data;
        //             this.fclScheduleSub = res.data;
        //             if(isInit) this.setPage3(1);
        //             else{
        //                 this.search3(false);
        //             }
        //         }
        //     }
        // );
    }

    setPage(page:number){

        this.pager = this.pagerService.getPager(this.portMapList.length, page, Number(this.condition.pageSize));

        // if (page < 1) {
        //   return;
        // }
    
        if(page > this.pager.totalPages) {
          this.pager = this.pagerService.getPager(this.portMapList.length, this.pager.totalPages);
        }
    
        this.pagedItems = this.portMapList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }

    setPage2(page:number){

        this.pager2 = this.pagerService.getPager(this.portMapList2.length, page, 10);

        // if (page < 1) {
        //   return;
        // }
    
        if(page > this.pager2.totalPages) {
          this.pager2 = this.pagerService.getPager(this.portMapList2.length, this.pager2.totalPages);
        }
    
        this.pagedItems2 = this.portMapList2.slice(this.pager2.startIndex, this.pager2.endIndex + 1);
    }

    setPage3(page:number){

        this.pager3 = this.pagerService.getPager(this.fclScheduleSub.length, page, 10);

        // if (page < 1) {
        //   return;
        // }
    
        if(page > this.pager3.totalPages) {
          this.pager3 = this.pagerService.getPager(this.fclScheduleSub.length, this.pager3.totalPages);
        }
    
        this.pagedItems3 = this.fclScheduleSub.slice(this.pager3.startIndex, this.pager3.endIndex + 1);
    }
    

    search(type:string, event){
        if(type == null){
            
        }else if(type.indexOf('operType') > -1){
            this.condition.operType = event;
        }else if(type.indexOf('initial') > -1){
            this.condition.initial = event;
        }else if(type.indexOf('status') > -1){
            this.condition.status = event;
        }else if(type.indexOf('search') > -1){
            if(event.keyCode != 13) return;
        }

        var filterValue = this.condition.text;

        if(this.allPortMapList && this.allPortMapList.length < 1) {
            this.pagedItems = new Array();
            this.pager = new Array();
            return;
        }

        this.portMapList = _.filter(this.allPortMapList, (item:PortNmMapModel) => {
            if(this.condition.operType == 'ALL') return true;
            else if(!item.operCd) return false;
            else if(item.operCd.indexOf(this.condition.operType) > -1) return true;
            else return false;
        });

        this.portMapList = _.filter(this.portMapList, (item:PortNmMapModel) => {
            let firstChar = item.operPortNm.trim().charAt(0).toLocaleLowerCase();
            if(this.condition.initial == 'ALL') return true;
            else if(this.condition.initial != '기타' && !item.operTpNm) return false;
            else if(this.condition.initial != '기타' && firstChar.indexOf(this.condition.initial.toLocaleLowerCase()) > -1) return true;
            else if(this.condition.initial == '기타'){
                var strReg = /^[A-Za-z]+$/; 
                if(!strReg.test(firstChar)){
                    return true;
                }
            }
            else return false;
        });

        // this.portMapList = _.filter(this.portMapList, (item:PortNmMapModel) => {
        //     if(this.condition.status == 'ALL' && item.stusNm.indexOf('SKIP') < 0) {
        //         return true;
        //     }else if(item.stusNm.indexOf(this.condition.status) > -1){
        //         return true;
        //     }
        //     else return false;
        // });

        this.portMapList = _.filter(this.portMapList, item => {
                if (!filterValue) return true;

                let valuesStr = Util.getString(item);
                const filter = filterValue.toLocaleLowerCase().replace(/\s/gi, "");
                return valuesStr.indexOf(filter) >= 0;
        });

        // this.portMapList = _.orderBy(this.portMapList, '[operPortNm]', '[desc]');
        

        if(type != null){
            this.setPage(1);
        }else{
            this.setPage(this.pager.currentPage);
        }
    }

    search2(event) {

        var filterValue = this.condition2.text;
        
        if(event && event.keyCode != 13) return;
              
        // if(this.allPortMapList2.length < 1) return;

        this.portMapList2 = _.filter(this.allPortMapList2, item => {
                if (!filterValue) return true;

                let valuesStr = Util.getString(item);
                const filter = filterValue.toLocaleLowerCase().replace(/\s/gi, "");
                return valuesStr.indexOf(filter) >= 0;
        });
        
        if(event) this.setPage2(1);
        else this.setPage2(this.pager2.currentPage == 0 ? 1 : this.pager2.currentPage);
    }

    search3(event) {

        var filterValue = this.condition3.text;
        
        if(event && event.keyCode != 13) return;
              
        // if(this.allPortMapList2.length < 1) return;

        this.fclScheduleSub = _.filter(this.allFclScheduleSub, item => {
                if (!filterValue) return true;

                let valuesStr = Util.getString(item);
                const filter = filterValue.toLocaleLowerCase().replace(/\s/gi, "");
                return valuesStr.indexOf(filter) >= 0;
        });
        
        if(event) this.setPage3(1);
        else this.setPage3(this.pager3.currentPage == 0 ? 1 : this.pager3.currentPage);
    }
    
    selectedChecked(event){
        this.condition.checkedType = event;

        this.portMapList = _.filter(this.allPortMapList, (item:PortNmMapModel) => {
            if(this.condition.checkedType == 'ALL') return true;
            else if(this.condition.checkedType == 'TRUE' && item.isChecked) return true;
            // else if(this.condition1.checkedType == 'FALSE' && !item.isChecked) return true;
            else return false;
        });

        this.setPage(1);
    }

    findPort(operPortNm:string, portNmMapId:number){
        this.clickedPortNmMapId = portNmMapId;
        this.onFindPort.emit({operPortNm:operPortNm, portNmMapId:portNmMapId});
    }

    portMapChecked(index, fieldNm, checked){
        if(this.pagedItems[index]) this.pagedItems[index][fieldNm] = checked;
    }

    checkAll(isChecked) {
        this.allMappingMapChecked = true;
        if (_.isEmpty(this.pagedItems)) return;
        for(let k = 0 ; k < this.pagedItems.length; k++) {
            this.pagedItems[k].isChecked = isChecked;
        }
    }

    doMapping(){
        
        let that = this;

        $.sweetModal.confirm('매핑을 진행하시겠습니까??', function() {
            if(that.tabIndex != 0){
                $.sweetModal({
                    content: "Mapping 탭에서만 이용 가능합니다.",
                    icon: $.sweetModal.ICON_WARNING,
                });
                return;
            }
    
            if(!that.locationId){
                $.sweetModal({
                    content: "매핑할 항만의 값이 존재하지 않습니다. 상단에서 항만을 선택해주세요.",
                    icon: $.sweetModal.ICON_WARNING,
                });
                return;
            } 
    
            that.tempPortMapList = _.map(
                    _.filter(that.allPortMapList, 
                        (portMap:PortNmMapModel) => {
                        if(portMap.isChecked) return true;
                    }),
                    (portMap:PortNmMapModel) =>{
                        portMap.location = new SaveLocationModel();
                        portMap.location.locationId = that.locationId;
                        portMap.stusCd = 1;
                        return portMap;
                    }
                    
            );

            if(that.tempPortMapList.length < 1){
                $.sweetModal({
                    content: "매핑할 Port Map 값이 존재하지 않습니다. Port Map을 선택해주세요.",
                    icon: $.sweetModal.ICON_WARNING,
                });
                return;
            }

            that.portService.patchPortMap(that.tempPortMapList).subscribe( res => {
                if(res.result){
                    that.alertService.success('매핑이 완료 되었습니다.');
                    that.refreshPortMap(1);
                }
            });


        }, function() {
            
        });
    }

    refreshPortMap(event){
        if(event == 1) this.getPortMapList(false);
        this.closeUpdateList();
        // else if(event == 2 && this.locationId != null && this.locationId != undefined) {
        //     this.getPortMapListByLocationId(this.locationId, false);
        // }
    } 

    openPortMapUpdate(){
        this.updTargetList = _.cloneDeep(
            _.filter(this.allPortMapList, 
                (portMap:PortNmMapModel) => {
                if(portMap.isChecked) return true;
            })
        );

        this.isOpenPortMapUpdate = true;
    }

    tabClick(index){
        this.tabIndex = index;
    }

    getListByStatus(event){
        this.condition.status = event;
        this.getPortMapList(true);
    }

    selectedPageSize(event){
        this.condition.pageSize = event;
        this.setPage(1);
    }

    closeUpdateList(){
        this.isOpenPortMapUpdate = false;
    }
}

class ConditionSearch {
    text:string = "";
    operType:string = "ALL";
    initial:string = "ALL";
    status:number = 0;
    checkedType:string = "ALL";
    pageSize:number = 10;
}

class ConditionSearch2{
    text:string = "";
}


// WEBPACK FOOTER //
// ./src/app/containers/port-map/port-map-list.ts